import type { GetPrizesElementResponseType } from "@jti/rest-api-types";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

type TrackRedeemClickParams = {
  name?: GetPrizesElementResponseType["name"];
  locations?: GetPrizesElementResponseType["locations"] | null;
};

export const trackRedeemClick = ({ name, locations }: TrackRedeemClickParams) => {
  return dispatchTrackingEvent(TrackingEvents.TrackingRedeemClick, {
    reward: name ?? "",
    sensory_experience: !!locations?.length,
  });
};
